import React, { useCallback, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import ConfirmDialog from "../../components/ConfirmDialog";
import { isBlank, notBlank } from "../../util/ext";
import Paper from "@material-ui/core/Paper";
import { useConfirm } from "../../common/use-confirm";
import {
  any,
  append,
  concat,
  difference,
  equals,
  map,
  prop,
  propEq,
  reject,
  sortBy,
  without,
} from "ramda";
import Grid from "@material-ui/core/Grid";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import DialogContentText from "@material-ui/core/DialogContentText";
import { useDocumentFormats, useImageFormats } from "../cspServices";
import { caseInsensitiveSort } from "../../util/sorts";

const useStyles = makeStyles(theme => ({
  form: {
    marginTop: theme.spacing(3),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

const sortMediumFormats = caseInsensitiveSort("display");

const MediumFormatsDialog = ({ open, onCancel, onApply, submissionType }) => {
  const classes = useStyles();

  //-- Manage the confirm dialog
  const confirmHandler = useConfirm();
  const { showConfirm } = confirmHandler;

  const [available, setAvailable] = useState([]);
  const [selected, setSelected] = useState([]);

  const documentFormatsResponse = useDocumentFormats();
  const imageFormatsResponse = useImageFormats();
  useEffect(() => {
    if (documentFormatsResponse.isSuccess && imageFormatsResponse.isSuccess) {
      const formats = equals(submissionType.name, "IMAGE")
        ? imageFormatsResponse.data
        : documentFormatsResponse.data;

      if (notBlank(submissionType.mediumFormats)) {
        setSelected(submissionType.mediumFormats);
        const unused = reject(
          format =>
            any(propEq("name", format.name), submissionType.mediumFormats),
          formats,
        );

        setAvailable(
          sortBy(prop("name"), concat(submissionType.mediumFormats, unused)),
        );
      } else {
        setAvailable(formats);
      }
    }
  }, [
    documentFormatsResponse.isSuccess,
    documentFormatsResponse.data,
    imageFormatsResponse.isSuccess,
    imageFormatsResponse.data,
    submissionType.mediumFormats,
    submissionType.name,
  ]);

  const handleClose = useCallback(() => {
    const previous = notBlank(submissionType.mediumFormats)
      ? submissionType.mediumFormats
      : [];
    if (isBlank(difference(selected, previous))) {
      onCancel();
    } else {
      showConfirm(
        "Discard Changes?",
        "You have selected formats without applying.  Do you wish to discard these changes?",
        {
          onConfirm: () => {
            onCancel();
          },
        },
      );
    }
  }, [selected, submissionType.mediumFormats, showConfirm, onCancel]);

  const handleApply = useCallback(() => {
    onApply(selected);
  }, [onApply, selected]);

  const handleSelected = format => event => {
    if (event.target.checked) {
      setSelected(prev => append(format, prev));
    } else {
      setSelected(prev => without([format], prev));
    }
  };

  return (
    <Dialog open={open} maxWidth="md">
      <DialogTitle id="add-submission-types-dialog-title">
        Update Medium Formats
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {`Check the Formats that should allowed for ${submissionType.displayName} submissions`}
        </DialogContentText>
        <Paper>
          <Box className={classes.form}>
            <Grid spacing={2} container>
              {map(
                format => (
                  <Grid key={format.name} item md={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={any(propEq("name", format.name), selected)}
                          onChange={handleSelected(format)}
                          name={format.name}
                          color="primary"
                        />
                      }
                      label={format.display}
                    />
                  </Grid>
                ),
                sortMediumFormats(available),
              )}
            </Grid>
          </Box>
        </Paper>
        <ConfirmDialog handler={confirmHandler} />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleApply} color="primary">
          Apply
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MediumFormatsDialog;
